import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

export class  ClassValueCalendar{
    constructor(
      public toDate:NgbDate| null,
      public fromDate:NgbDate| null
    ){}
  }